<template>
  <div class="questions">
    <b-jumbotron>
      <template>{{ currentquestions.question }}</template>
      <hr class="my-4" />
      <b-list-group>
        <b-list-group-item
          v-for="(shuffledanswer , index) in shuffledanswers"
          :key="index"
          @click.prevent="selectanswer(index)"
          :class="answeredClass(index)"
        >{{shuffledanswer}}</b-list-group-item>
      </b-list-group>

      <b-button
        variant="primary"
        @click="submitanswer"
        :disabled="selectedIndex === null || answered"
      >submit</b-button>

      <b-button @click="next" variant="success" :disabled="index === questions.length - 1 ">next</b-button>
    </b-jumbotron>
  </div>
</template>

<script>
import _ from 'lodash' // to install it  npm i lodash
export default {
  name: 'questions',
  props: {
    currentquestions: Object,
    next: Function,
    increase: Function,
    questions: Array,
    index: Number
  },
  data () {
    return {
      selectedIndex: null,
      correctIndex: null,
      answered: false,
      shuffledanswers: []
    }
  },
  methods: {
    selectanswer (index) {
      this.selectedIndex = index
    },
    shuffleanswers () {
      let answers = [
        ...this.currentquestions.incorrect_answers,
        this.currentquestions.correct_answer
      ]
      this.shuffledanswers = _.shuffle(answers)
      this.correctIndex = this.shuffledanswers.indexOf(
        this.currentquestions.correct_answer
      )
    },
    submitanswer () {
      let isCorrect = false
      if (this.selectedIndex === this.correctIndex) {
        isCorrect = true
      }
      this.answered = true
      this.increase(isCorrect)
      if (this.index === this.questions.length - 1) {
        alert('this will be the last answer in this filed')
      }
    },
    answeredClass (index) {
      let answeredClass = ''
      if (!this.answered && this.selectedIndex === index) {
        answeredClass = 'selected'
      } else if (this.answered && this.correctIndex === index) {
        answeredClass = 'correct'
      } else if (
        this.answered &&
        this.selectedIndex === index &&
        this.correctIndex !== index
      ) {
        answeredClass = 'incorrect'
      }
      return answeredClass
    }
  },
  watch: {
    currentquestions: {
      immediate: true,
      handler () {
        (this.selectedIndex = null),
        (this.answered = false),
        this.shuffleanswers()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

<!--
:class="[
          !answered && selectedIndex === index ? 'selected' :
          answered && correctIndex === index ? 'correct' :
          answered && selectedIndex===index && correctIndex !== index ? 'incorrect' : ''
          ]"-->
